<template>
    <div class="linear-gradient-v-1093FF-to-69BBFF">
        <tool-bar :arrow="require('../../assets/icon_nav_white.png')"
                  title="USSD"
                  title-color="#FFFFFF"></tool-bar>

        <div class="margin-t-70 flex-h flex-h-center">
            <div class="h-75 w-75 font-bold font-30 color-1477FE bg-FFFFFF border-p-50 flex-h flex-v-center flex-h-center">
                {{bankInfo.bankCode}}
            </div>
        </div>

        <div class="font-bold font-16 color-FFFFFF margin-t-28" style="text-align: center">
            <div>Dial the code below to complete this-</div>
            <div>transaction with {{bankInfo.bankName}}} {{bankInfo.bankCode}}</div>
        </div>

        <div class="margin-t-56 font-35 font-bold color-FFFFFF" style="text-align: center">
            {{ussdInfo.ussdCode}}
        </div>

        <div class="flex-h flex-h-center margin-t-22 padding-b-90">
            <div class="w-150 radius-19 bg-1477FE color-FFFFFF font-bold font-19"
                 style="text-align: center;display: inline-block;line-height: 38px;"
                 @click="call(ussdInfo.ussdCode)">
                Click to dial
            </div>
        </div>

        <div class="bg-FFFFFF h-71 flex-v flex-h-center" style="position: fixed;bottom: 0;width: 100%">
            <div class="padding-h-15">
                <van-button style="font-size: 19px;border-radius: 8px;height: 55px;"
                            color="linear-gradient(to right,#1093FF, #69BBFF)"
                            @click="haveCompletePay()"
                            block>
                    I’ve completed the transaction
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "repayment_ussd",
        data() {
            return {
                bankInfo: {
                    bankCode: '',
                    bankName: ''
                },
                ussdInfo: {}
            };
        },
        methods: {
            call(phone) {
                window.location.href = 'tel:' + phone; // 拨打电话
            },
            haveCompletePay() {
                this.$router.go(-1)
            }
        },
        mounted() {
            let bankStr = this.$route.query.bank
            if (bankStr) {
                this.bankInfo = JSON.parse(bankStr)
            }
            let ussdStr = this.$route.query.ussd
            if (ussdStr) {
                this.ussdInfo = JSON.parse(ussdStr)
            }
        },
        beforeRouteEnter(to, from, next) {
            // 添加背景色
            document.querySelector('body').setAttribute('style', 'background-color:#F5F7FA')
            next()
        },
        beforeRouteLeave(to, from, next) {
            //去除背景色
            document.querySelector('body').setAttribute('style', '')
            next()
        },
    }
</script>

<style scoped>

</style>